import { api } from "@/lib/api/client";

/**
 * Cliente del módulo Newsletter (#14) en Nexus.
 *
 * Endpoints admin en mn-server (JwtAuth + requirePermission(newsletter:manage)):
 *   GET  /api/nexus/newsletter/editions          → listar ediciones
 *   POST /api/nexus/newsletter/editions          → crear edición (draft)
 *   POST /api/nexus/newsletter/editions/:id/send → segmentar + enviar (one-shot)
 *
 * Las respuestas vienen envueltas en `{ success, ... }` (envelope del
 * backend), por eso desempaquetamos el campo útil acá — mismo patrón que
 * modules/applications/api.ts.
 */

export type NewsletterEditionStatus = "draft" | "sent";

export type NewsletterEdition = {
  id: number;
  subject: string;
  bodyHtml: string;
  segmentCities: string[];
  segmentGenres: string[];
  status: NewsletterEditionStatus | string;
  sentAt: string | null;
  recipientCount: number;
  createdAt: string;
};

export type CreateEditionInput = {
  subject: string;
  bodyHtml: string;
  segmentCities?: string[];
  segmentGenres?: string[];
};

export type SendEditionResult = {
  edition: NewsletterEdition;
  sent: number;
  failed: number;
};

export const newsletterApi = {
  listEditions: async (): Promise<NewsletterEdition[]> => {
    const { data } = await api.get<{ success: boolean; editions: NewsletterEdition[] }>(
      "/api/nexus/newsletter/editions",
    );
    return data.editions ?? [];
  },

  createEdition: async (body: CreateEditionInput): Promise<NewsletterEdition> => {
    const { data } = await api.post<{ success: boolean; edition: NewsletterEdition }>(
      "/api/nexus/newsletter/editions",
      body,
    );
    return data.edition;
  },

  sendEdition: async (id: number): Promise<SendEditionResult> => {
    const { data } = await api.post<{
      success: boolean;
      edition: NewsletterEdition;
      sent: number;
      failed: number;
    }>(`/api/nexus/newsletter/editions/${id}/send`);
    return { edition: data.edition, sent: data.sent, failed: data.failed };
  },
};
